import React from "react";
import {Alert, Button} from "reactstrap";
import ConfirmModal from "../../../shared/components/ConfirmModal";
import IconLabel from "../../../shared/components/IconLabel";
import {ACTIONS, FLOW} from "./actionConfig";

/**
 * The buttons that move an order along its flow, to the right: the main step
 * solid, alternatives outlined. Also where the confirmation dialog and the
 * error of any order action (the menu's too) are shown.
 * @param {{
 *   order: import("../../../api/types").Order,
 *   action: ReturnType<typeof import("./useOrderAction").useOrderAction>,
 * }} props
 */
const OrderActions = ({order, action}) => {
    const available = order.available_actions ?? [];
    const flow = FLOW.filter((name) => available.includes(name));
    const {pending, busy, error} = action;

    if (!flow.length && !error && !pending) return null;

    return (
        <>
            {error && (
                <Alert color="danger" className="mb-3">
                    {error}
                </Alert>
            )}
            {flow.length > 0 && (
                <div className="d-flex flex-wrap justify-content-end gap-2">
                    {flow.map((name, index) => {
                        const {icon: Icon, label, color} = ACTIONS[name];
                        return (
                            <Button key={name} color={color} outline={index > 0} onClick={() => action.ask(name)}>
                                <IconLabel icon={<Icon />}>{label}</IconLabel>
                            </Button>
                        );
                    })}
                </div>
            )}
            {pending && (
                <ConfirmModal
                    isOpen
                    title={ACTIONS[pending].title}
                    message={ACTIONS[pending].message}
                    confirmLabel={ACTIONS[pending].label}
                    confirmIcon={ACTIONS[pending].icon}
                    color={ACTIONS[pending].color}
                    busy={busy}
                    onConfirm={action.run}
                    onCancel={action.dismiss}
                />
            )}
        </>
    );
};

export default OrderActions;
